import { useRef } from 'react';
export const useSpecificUsers = userIds => {
  const specificUsers = useRef();
  if (!specificUsers.current && Array.isArray(userIds)) {
    specificUsers.current = userIds;
  }
  return specificUsers.current;
};